module.exports = __webpack_public_path__ + "static/media/emoji2.5685d9a2.png";